import classNames from 'classnames';
import { UiKitButton } from '@components/common/ui-kit-button';
import type { TpButtonProps } from '@mentalgrowth/ui-kit-web';

import styles from './circle-button.module.scss';

const CircleButton = ({
  className,
  ...props
}: TpButtonProps & { 'data-testid'?: string }) => (
  <UiKitButton
    className={classNames(styles.container, className)}
    color="pure"
    {...props}
  />
);

CircleButton.displayName = 'CircleButton';
export default CircleButton;
